<template>
    <div class="commitments">
        <a class="container-fluid" :href="commitments.url" target="_blank">
            <div class="row pt-2 bg-white">
                <header-signature class="col-12 py-0" :text="commitments.title" />
            </div>
            <div class="row bg-white">
                <div class="col-12 col-md-3">
                    <div class="d-flex align-items-center mb-1 mb-md-2">
                        <span class="icon h1 mb-0 pb-0 icon-Fast-delivery text-secondary" aria-hidden="true" />
                        <span class="mx-1 font-weight-bold">{{ commitments.line1 }}</span>
                    </div>
                </div>
                <div class="col-12 col-md-3 pl-lg-2">
                    <div class="d-flex align-items-center mb-1 mb-md-2">
                        <span class="icon h1 mb-0 pb-0 icon-finance text-secondary" aria-hidden="true" />
                        <span class="mx-1 font-weight-bold">{{ commitments.line2 }}</span>
                    </div>
                </div>
                <div class="col-12 col-md-3 pl-lg-2">
                    <div class="d-flex align-items-center mb-1 mb-md-2">
                        <span class="icon h1 mb-0 pb-0 icon-Orange-Trust-Badge text-secondary" aria-hidden="true" />
                        <span class="mx-1 font-weight-bold">{{ commitments.line4 }}</span>
                    </div>
                </div>
                <div class="col-12 col-md-3 pl-lg-2">
                    <div class="d-flex align-items-center mb-1 mb-md-2">
                        <span class="icon h1 mb-0 pb-0 icon-shop-subscriptions text-secondary" aria-hidden="true" />
                        <span class="mx-1 font-weight-bold">{{ commitments.line5 }}</span>
                    </div>
                </div>
            </div>
        </a>
    </div>
</template>

<script>
import HeaderSignature from "../../../common/components/vue/HeaderSignature.vue";

export default {
    components: {HeaderSignature},
    props: {
        commitments: {
            type: Object,
            required: true,
        }
    }
}
</script>
